import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.25 8.625C7.95163 8.625 7.66548 8.74353 7.4545 8.9545C7.24353 9.16548 7.125 9.45163 7.125 9.75C7.125 10.0484 7.24353 10.3345 7.4545 10.5455C7.66548 10.7565 7.95163 10.875 8.25 10.875C8.54837 10.875 8.83452 10.7565 9.0455 10.5455C9.25648 10.3345 9.375 10.0484 9.375 9.75C9.375 9.45163 9.25648 9.16548 9.0455 8.9545C8.83452 8.74352 8.54837 8.625 8.25 8.625Z"
        fill={colorValue}
      />
      <path
        d="M12 8.625C11.7016 8.625 11.4155 8.74352 11.2045 8.9545C10.9935 9.16548 10.875 9.45163 10.875 9.75C10.875 10.0484 10.9935 10.3345 11.2045 10.5455C11.4155 10.7565 11.7016 10.875 12 10.875C12.2984 10.875 12.5845 10.7565 12.7955 10.5455C13.0065 10.3345 13.125 10.0484 13.125 9.75C13.125 9.45163 13.0065 9.16548 12.7955 8.9545C12.5845 8.74352 12.2984 8.625 12 8.625Z"
        fill={colorValue}
      />
      <path
        d="M15.75 8.625C15.4516 8.625 15.1655 8.74352 14.9545 8.9545C14.7435 9.16548 14.625 9.45163 14.625 9.75C14.625 10.0484 14.7435 10.3345 14.9545 10.5455C15.1655 10.7565 15.4516 10.875 15.75 10.875C16.0484 10.875 16.3345 10.7565 16.5455 10.5455C16.7565 10.3345 16.875 10.0484 16.875 9.75C16.875 9.45163 16.7565 9.16548 16.5455 8.9545C16.3345 8.74352 16.0484 8.625 15.75 8.625Z"
        fill={colorValue}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.25C14.3935 2.24926 16.7838 2.42337 19.1519 2.77095C21.1302 3.06196 22.5 4.79409 22.5 6.741V12.759C22.5 14.7061 21.1303 16.4381 19.1511 16.729C17.1896 17.0171 15.2124 17.186 13.2304 17.2348L13.2294 17.2348C13.1297 17.2371 13.0346 17.2776 12.9638 17.3479L8.78027 21.5304C8.56575 21.7449 8.24318 21.809 7.96295 21.6929C7.68271 21.5768 7.5 21.3033 7.5 21V17.0452C6.60944 16.9635 5.72521 16.8582 4.84785 16.729C2.86957 16.438 1.5 14.7049 1.5 12.76V6.741C1.5 4.79523 2.86945 3.062 4.84791 2.77098C7.18284 2.4277 9.57146 2.25001 12 2.25ZM18.9339 4.25502C16.638 3.91806 14.3207 3.74927 12.0002 3.75C9.64488 3.75 7.32912 3.92232 5.06615 4.25502C3.87663 4.43002 3 5.48479 3 6.741V12.76C3 14.0151 3.87647 15.07 5.06615 15.245C6.13594 15.4025 7.21694 15.5236 8.30804 15.6083C8.69857 15.6386 9 15.9643 9 16.356V19.1896L11.9037 16.2866L11.9047 16.2856C12.2479 15.9438 12.7098 15.7467 13.1941 15.7352C15.1152 15.6879 17.0317 15.5242 18.933 15.245C20.1237 15.0699 21 14.0159 21 12.759V6.741C21 5.484 20.1234 4.43012 18.9339 4.25502Z"
        fill={colorValue}
      />
    </svg>
  );
};
